<!-- <div class="fullscreen-modal-content-wrapper">

  <div class="modal-header-custom">
    <h3 class="modal-title-custom">Generate PDF</h3>
    <div nz-alert nzType="warning"
      nzMessage="This data will not be saved. Closing the window will discard all entered information." nzShowIcon
      class="top-warning-alert"></div>
    <button nz-button nzType="text" class="close-button-custom" (click)="closeModal()">
      <i nz-icon nzType="close" nzTheme="outline"></i>
    </button>
  </div>

  <div class="main-content-wrapper">
    <div class="step-items-wrapper">
      <nz-steps [nzCurrent]="stepIndex" (nzIndexChange)="onIndexChange($event)">
        <nz-step nzTitle="Basic Details"></nz-step>
        <nz-step nzTitle="Other Details" [nzDisabled]="highestStepVisited < 1"></nz-step>
        <nz-step nzTitle="Sourcing Needs" [nzDisabled]="highestStepVisited < 2"></nz-step>
        <nz-step nzTitle="Compliance & Safety" [nzDisabled]="highestStepVisited < 3"></nz-step>
        <nz-step nzTitle="Review & Generate" [nzDisabled]="highestStepVisited < 4"></nz-step>
      </nz-steps>
    </div>

    <div class="step-content">

      <div *ngIf="stepIndex === 0">
        <h2>Basic Details</h2>
        <form nz-form [formGroup]="validateForm" (ngSubmit)="submitForm()" class="editable-details-form">
          <h3 class="mt-4">Editable Details</h3>

          <nz-form-item nz-row>
            <nz-form-label [nzSm]="6" [nzXs]="24" nzFor="eventName" nzRequired>Event Name</nz-form-label>
            <nz-form-control [nzSm]="14" [nzXs]="24" nzErrorTip="Event Name is required.">
              <input nz-input formControlName="eventName" id="eventName" placeholder="Enter Event Name" />
            </nz-form-control>
          </nz-form-item>

          <nz-form-item nz-row>
            <nz-form-label [nzSm]="6" [nzXs]="24" nzFor="eventStartDate" nzRequired>Event Start Date</nz-form-label>
            <nz-form-control [nzSm]="14" [nzXs]="24" nzErrorTip="Event Start Date is required.">
              <input nz-input type="text" formControlName="eventStartDate" id="eventStartDate" />
            </nz-form-control>
          </nz-form-item>

          <nz-form-item nz-row>
            <nz-form-label [nzSm]="6" [nzXs]="24" nzFor="eventEndDate" nzRequired>Event End Date</nz-form-label>
            <nz-form-control [nzSm]="14" [nzXs]="24" nzErrorTip="Event End Date is required.">
              <input nz-input type="text" formControlName="eventEndDate" id="eventEndDate" />
            </nz-form-control>
          </nz-form-item>

          <nz-form-item nz-row style="margin-bottom: 0;">
            <nz-form-control [nzSpan]="14" [nzOffset]="6">
              <label nz-checkbox formControlName="includeCoverPage">Include Cover Page</label>
            </nz-form-control>
          </nz-form-item>
          <nz-form-item nz-row>
            <nz-form-control [nzSpan]="14" [nzOffset]="6">
              <label nz-checkbox formControlName="includeThankYouPage">Include Thank You Page</label>
            </nz-form-control>
          </nz-form-item>

          <h3 class="mt-4">Additional Information</h3>
          <nz-descriptions nzBordered nzSize="small" [nzColumn]="{ xxl: 2, xl: 2, lg: 2, md: 1, sm: 1, xs: 1 }">
            <ng-container *ngFor="let item of displayData">
              <nz-descriptions-item [nzTitle]="item.label">
                <a *ngIf="item.isLink" [href]="item.value" target="_blank">{{ formatUrl(item.value) }}</a>
                <ng-container *ngIf="!item.isLink">{{ item.value || 'N/A' }}</ng-container>
              </nz-descriptions-item>
            </ng-container>
          </nz-descriptions>

          <nz-form-item nz-row class="register-area">
            <nz-form-control [nzSpan]="14">
              <div class="form-actions">
                <button nz-button nzType="primary">Next</button>
              </div>
            </nz-form-control>
          </nz-form-item>
        </form>
      </div>

      <div *ngIf="stepIndex === 1">
        <h2>Other Details</h2>
        <form nz-form [formGroup]="otherDetailsForm" (ngSubmit)="submitForm()">
          <div class="answers-table-container">
            <nz-table #detailsTable [nzData]="detailsFormArray.controls" nzSize="middle" [nzShowPagination]="false">
              <thead>
                <tr>
                  <th nzWidth="50px">Include</th>
                  <th>Form</th>
                  <th>Value</th>
                  <th nzWidth="50px">Actions</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let control of detailsFormArray.controls; let j = index; trackBy: trackByIndex"
                  [formGroup]="$any(control)">
                  <td><label nz-checkbox formControlName="selected"></label></td>
                  <td><textarea nz-input rows="1" formControlName="questionText"></textarea></td>
                  <td><textarea nz-input rows="1" formControlName="answerText"></textarea></td>
                  <td>
                    <button nz-button nzDanger nzSize="small" nzShape="circle"
                      (click)="removeCustomRow(detailsFormArray, j)"
                      [disabled]="control.get('originalId')?.value !== null" type="button"
                      nz-tooltip="Remove Custom Row">
                      <i nz-icon nzType="delete" nzTheme="fill"></i>
                    </button>
                  </td>
                </tr>
              </tbody>
            </nz-table>
          </div>
          <div class="text-right" style="margin-top: 10px;">
            <button nz-button nzType="dashed" (click)="addCustomRow(detailsFormArray, 'detail')" type="button">
              <i nz-icon nzType="plus"></i> Add Custom Field
            </button>
          </div>
          <nz-form-item nz-row class="register-area">
            <nz-form-control [nzSpan]="14">
              <div class="form-actions">
                <button nz-button type="button" (click)="goToPreviousStep()">Back</button>
                <button nz-button nzType="primary" type="submit">Next</button>
              </div>
            </nz-form-control>
          </nz-form-item>
        </form>
      </div>

      <div *ngIf="stepIndex === 2">
        <h2>Sourcing Needs</h2>
        <form nz-form [formGroup]="sourcingNeedsForm" (ngSubmit)="submitForm()">
          <nz-collapse [nzAccordion]="true" class="sourcing-needs-collapse-container" style="box-shadow: none;">
            <nz-collapse-panel *ngFor="let category of sourcingNeedsCategories; let i = index"
              [formGroupName]="category.key"
              [nzHeader]="getEmoji(category.requiredFlag) + '  ' + category.control.get('label')?.value"
              [nzActive]="i === 0" class="sourcing-needs-collapse-panel">

              <div class="answers-table-container" formArrayName="items">
                <nz-table [nzData]="getSourcingNeedsFormArray(category.key).controls" nzSize="middle"
                  [nzShowPagination]="false">
                  <thead>
                    <tr>
                      <th nzWidth="50px">Include</th>
                      <th>Need</th>
                      <th>Value</th>
                      <th nzWidth="50px">Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      *ngFor="let control of getSourcingNeedsFormArray(category.key).controls; let j = index; trackBy: trackByIndex"
                      [formGroup]="$any(control)">
                      <td><label nz-checkbox formControlName="selected"></label></td>
                      <td><textarea nz-input rows="2" formControlName="questionText"
                          [readOnly]="control.get('originalId')?.value !== null"></textarea></td>
                      <td><textarea nz-input rows="2" formControlName="answerText"></textarea></td>
                      <td>
                        <button nz-button nzDanger nzSize="small" nzShape="circle"
                          (click)="removeCustomRow(getSourcingNeedsFormArray(category.key), j)"
                          [disabled]="control.get('originalId')?.value !== null" type="button"
                          nz-tooltip="Remove Custom Need">
                          <i nz-icon nzType="delete" nzTheme="fill"></i>
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </nz-table>
              </div>
              <div class="text-right" style="margin-top: 10px;">
                <button nz-button nzType="dashed"
                  (click)="addCustomRow(getSourcingNeedsFormArray(category.key), 'detail')" type="button">
                  <i nz-icon nzType="plus"></i> Add Custom Need
                </button>
              </div>

            </nz-collapse-panel>
          </nz-collapse>
          <nz-form-item nz-row class="register-area">
            <nz-form-control [nzSpan]="14">
              <div class="form-actions">
                <button nz-button type="button" (click)="goToPreviousStep()">Back</button>
                <button nz-button nzType="primary" type="submit">Next</button>
              </div>
            </nz-form-control>
          </nz-form-item>
        </form>
      </div>

      <div *ngIf="stepIndex === 3">
        <h2>Compliance & Safety</h2>
        <form nz-form [formGroup]="complianceForm" (ngSubmit)="submitForm()">
          <nz-form-item>
            <nz-form-label [nzSm]="3" [nzXs]="24" style="display: flex;">Flexible Editing</nz-form-label>
            <nz-form-control [nzSm]="14" [nzXs]="24">
              <nz-switch formControlName="flexible"></nz-switch>
            </nz-form-control>
          </nz-form-item>

          <div class="answers-table-container" formArrayName="items">
            <nz-table #complianceTable [nzData]="complianceItemsArray.controls" nzSize="middle"
              [nzShowPagination]="false">
              <thead>
                <tr>
                  <th nzWidth="50px">Include</th>
                  <th [nzWidth]="complianceForm.get('flexible')?.value ? '30%' : null">Name <span
                      *ngIf="complianceForm.get('flexible')?.value" class="required-star">*</span></th>
                  <th *ngIf="complianceForm.get('flexible')?.value" nzWidth="120px">Currency <span
                      class="required-star">*</span></th>
                  <th *ngIf="complianceForm.get('flexible')?.value" nzWidth="120px">Amount</th>
                  <th *ngIf="complianceForm.get('flexible')?.value" nzWidth="120px">Exchange Rate</th>
                  <th *ngIf="complianceForm.get('flexible')?.value" nzWidth="120px">Amount (USD)</th>
                  <th *ngIf="!complianceForm.get('flexible')?.value">Yes / No</th>
                  <th nzWidth="50px">Actions</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let control of complianceItemsArray.controls; let j = index; trackBy: trackByIndex"
                  [formGroup]="$any(control)">
                  <td><label nz-checkbox formControlName="selected"></label></td>
                  <td><textarea nz-input rows="1" formControlName="name"></textarea></td>
                  <td *ngIf="complianceForm.get('flexible')?.value"><textarea nz-input rows="1"
                      formControlName="currency"></textarea></td>
                  <td *ngIf="complianceForm.get('flexible')?.value"><textarea nz-input rows="1"
                      formControlName="amount"></textarea></td>
                  <td *ngIf="complianceForm.get('flexible')?.value"><textarea nz-input rows="1"
                      formControlName="exchangeRate"></textarea></td>
                  <td *ngIf="complianceForm.get('flexible')?.value"><textarea nz-input rows="1"
                      formControlName="amountUsd"></textarea></td>
                  <td *ngIf="!complianceForm.get('flexible')?.value">
                    <nz-switch formControlName="simpleSelection"></nz-switch>
                  </td>
                  <td>
                    <button nz-button nzDanger nzSize="small" nzShape="circle"
                      (click)="removeCustomRow(complianceItemsArray, j)"
                      [disabled]="control.get('originalId')?.value !== null" type="button"
                      nz-tooltip="Remove Custom Item">
                      <i nz-icon nzType="delete" nzTheme="fill"></i>
                    </button>
                  </td>
                </tr>
              </tbody>
            </nz-table>
          </div>
          <div class="text-right" style="margin-top: 10px;">
            <button nz-button nzType="dashed" (click)="addCustomRow(complianceItemsArray, 'compliance')" type="button">
              <i nz-icon nzType="plus"></i> Add Custom Compliance Item
            </button>
          </div>
          <nz-form-item nz-row class="register-area">
            <nz-form-control [nzSpan]="14">
              <div class="form-actions">
                <button nz-button type="button" (click)="goToPreviousStep()">Back</button>
                <button nz-button nzType="primary" type="submit">Next</button>
              </div>
            </nz-form-control>
          </nz-form-item>
        </form>
      </div>


      <div *ngIf="stepIndex === 4">
        <h2>Review & Generate</h2>
        <div id="pdf-content">

          <h3>Basic Details</h3>
          <nz-descriptions nzBordered nzSize="small" [nzColumn]="2">
            <nz-descriptions-item nzTitle="Event Name">{{ reviewData.eventDetails?.eventName }}</nz-descriptions-item>
            <nz-descriptions-item nzTitle="Event Start Date">{{ reviewData.eventDetails?.eventStartDate }}</nz-descriptions-item>
            <nz-descriptions-item nzTitle="Event End Date">{{ reviewData.eventDetails?.eventEndDate }}</nz-descriptions-item>
            <nz-descriptions-item nzTitle="Include Cover Page">{{ reviewData.eventDetails?.includeCoverPage ? '✅' : '❌' }}</nz-descriptions-item>
            <nz-descriptions-item nzTitle="Include Thank You Page">{{ reviewData.eventDetails?.includeThankYouPage ? '✅' : '❌' }}</nz-descriptions-item>
          </nz-descriptions>

          <h3 class="mt-4">Other Details</h3>
          <nz-table [nzData]="reviewData.otherDetails?.details" nzSize="small" [nzShowPagination]="false">
            <thead>
              <tr>
                <th nzWidth="80px">Included</th>
                <th>Detail</th>
                <th>Value</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let detail of reviewData.otherDetails?.details">
                <td>{{ detail.selected ? '✅' : '❌' }}</td>
                <td>{{ detail.questionText }}</td>
                <td>{{ detail.answerText }}</td>
              </tr>
            </tbody>
          </nz-table>

          <ng-container *ngFor="let category of sourcingNeedsCategories">
            <div *ngIf="reviewData.sourcingNeeds?.[category.key]?.items?.length > 0">
              <h3 class="mt-4">{{ reviewData.sourcingNeeds[category.key].label }}</h3>
              <nz-table [nzData]="reviewData.sourcingNeeds[category.key].items" nzSize="small" [nzShowPagination]="false">
                <thead>
                  <tr>
                    <th nzWidth="80px">Included</th>
                    <th>Need</th>
                    <th>Value</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let item of reviewData.sourcingNeeds[category.key].items">
                    <td>{{ item.selected ? '✅' : '❌' }}</td>
                    <td>{{ item.questionText }}</td>
                    <td>{{ item.answerText }}</td>
                  </tr>
                </tbody>
              </nz-table>
            </div>
          </ng-container>

          <h3 class="mt-4">Compliance & Safety</h3>
          <nz-table [nzData]="reviewData.compliance?.items" nzSize="small" [nzShowPagination]="false">
            <thead>
              <tr>
                <th nzWidth="80px">Included</th>
                <th>Name</th>
                <th *ngIf="reviewData.compliance?.flexible">Currency</th>
                <th *ngIf="reviewData.compliance?.flexible">Amount</th>
                <th *ngIf="reviewData.compliance?.flexible">Exchange Rate</th>
                <th *ngIf="reviewData.compliance?.flexible">Amount (USD)</th>
                <th *ngIf="!reviewData.compliance?.flexible">Yes / No</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of reviewData.compliance?.items">
                <td>{{ item.selected ? '✅' : '❌' }}</td>
                <td>{{ item.name }}</td>
                <td *ngIf="reviewData.compliance?.flexible">{{ item.currency }}</td>
                <td *ngIf="reviewData.compliance?.flexible">{{ item.amount }}</td>
                <td *ngIf="reviewData.compliance?.flexible">{{ item.exchangeRate }}</td>
                <td *ngIf="reviewData.compliance?.flexible">{{ item.amountUsd }}</td>
                <td *ngIf="!reviewData.compliance?.flexible">{{ item.simpleSelection ? 'Yes' : 'No' }}</td>
              </tr>
            </tbody>
          </nz-table>
      </div>

      <div class="text-center mt-4">
        <div class="form-actions-review">
          <button nz-button type="button" (click)="goToPreviousStep()">Back</button>
          <button nz-button nzType="primary" (click)="onDownloadPdf()" [nzLoading]="isLoading">
            <i nz-icon nzType="file-pdf"></i> Download PDF
          </button>
        </div>
      </div>
</div>

    </div>
  </div>
</div> -->


<div class="fullscreen-modal-content-wrapper">

  <div class="modal-header-custom">
    <h3 class="modal-title-custom">Generate PDF</h3>
    <div nz-alert nzType="warning"
      nzMessage="This data will not be saved. Closing the window will discard all entered information." nzShowIcon
      class="top-warning-alert"></div>
    <button nz-button nzType="text" class="close-button-custom" (click)="closeModal()">
      <i nz-icon nzType="close" nzTheme="outline"></i>
    </button>
  </div>

  <div class="main-content-wrapper">
    <div class="step-items-wrapper">
      <nz-steps [nzCurrent]="stepIndex" (nzIndexChange)="onIndexChange($event)">
        <nz-step nzTitle="Basic Details"></nz-step>
        <nz-step nzTitle="Other Details" [nzDisabled]="highestStepVisited < 1"></nz-step>
        <nz-step nzTitle="Sourcing Needs" [nzDisabled]="highestStepVisited < 2"></nz-step>

        <nz-step *ngIf="showComplianceStep" nzTitle="Compliance & Safety" [nzDisabled]="highestStepVisited < 3"></nz-step>

        <nz-step nzTitle="Review & Generate" [nzDisabled]="highestStepVisited < (showComplianceStep ? 4 : 3)"></nz-step>
      </nz-steps>
    </div>

    <div class="step-content">

      <div *ngIf="stepIndex === 0">
        <h2>Basic Details</h2>
        <form nz-form [formGroup]="validateForm" (ngSubmit)="submitForm()" class="editable-details-form">
          <h3 class="mt-4">Editable Details</h3>

          <nz-form-item nz-row>
            <nz-form-label [nzSm]="6" [nzXs]="24" nzFor="eventName" nzRequired>Event Name</nz-form-label>
            <nz-form-control [nzSm]="14" [nzXs]="24" nzErrorTip="Event Name is required.">
              <input nz-input formControlName="eventName" id="eventName" placeholder="Enter Event Name" />
            </nz-form-control>
          </nz-form-item>

          <nz-form-item nz-row>
            <nz-form-label [nzSm]="6" [nzXs]="24" nzFor="eventStartDate" nzRequired>Event Start Date</nz-form-label>
            <nz-form-control [nzSm]="14" [nzXs]="24" nzErrorTip="Event Start Date is required.">
              <input nz-input type="text" formControlName="eventStartDate" id="eventStartDate" />
            </nz-form-control>
          </nz-form-item>

          <nz-form-item nz-row>
            <nz-form-label [nzSm]="6" [nzXs]="24" nzFor="eventEndDate" nzRequired>Event End Date</nz-form-label>
            <nz-form-control [nzSm]="14" [nzXs]="24" nzErrorTip="Event End Date is required.">
              <input nz-input type="text" formControlName="eventEndDate" id="eventEndDate" />
            </nz-form-control>
          </nz-form-item>

          <nz-form-item nz-row style="margin-bottom: 0;">
            <nz-form-control [nzSpan]="14" [nzOffset]="6">
              <label nz-checkbox formControlName="includeCoverPage">Include Cover Page</label>
            </nz-form-control>
          </nz-form-item>
          <nz-form-item nz-row>
            <nz-form-control [nzSpan]="14" [nzOffset]="6">
              <label nz-checkbox formControlName="includeThankYouPage">Include Thank You Page</label>
            </nz-form-control>
          </nz-form-item>

          <h3 class="mt-4">Additional Information</h3>
          <nz-descriptions nzBordered nzSize="small" [nzColumn]="{ xxl: 2, xl: 2, lg: 2, md: 1, sm: 1, xs: 1 }">
            <ng-container *ngFor="let item of displayData">
              <nz-descriptions-item [nzTitle]="item.label">
                <a *ngIf="item.isLink" [href]="item.value" target="_blank">{{ formatUrl(item.value) }}</a>
                <ng-container *ngIf="!item.isLink">{{ item.value || 'N/A' }}</ng-container>
              </nz-descriptions-item>
            </ng-container>
          </nz-descriptions>

          <nz-form-item nz-row class="register-area">
            <nz-form-control [nzSpan]="14">
              <div class="form-actions">
                <button nz-button nzType="primary">Next</button>
              </div>
            </nz-form-control>
          </nz-form-item>
        </form>
      </div>

      <div *ngIf="stepIndex === 1">
        <h2>Other Details</h2>
        <form nz-form [formGroup]="otherDetailsForm" (ngSubmit)="submitForm()">
          <div class="answers-table-container">
            <nz-table #detailsTable [nzData]="detailsFormArray.controls" nzSize="middle" [nzShowPagination]="false">
              <thead>
                <tr>
                  <th nzWidth="50px">Include</th>
                  <th>Form</th>
                  <th>Value</th>
                  <th nzWidth="50px">Actions</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let control of detailsFormArray.controls; let j = index; trackBy: trackByIndex"
                  [formGroup]="$any(control)">
                  <td><label nz-checkbox formControlName="selected"></label></td>
                  <td><textarea nz-input rows="1" formControlName="questionText"></textarea></td>
                  <td><textarea nz-input rows="1" formControlName="answerText"></textarea></td>
                  <td>
                    <button nz-button nzDanger nzSize="small" nzShape="circle"
                      (click)="removeCustomRow(detailsFormArray, j)"
                      [disabled]="control.get('originalId')?.value !== null" type="button"
                      nz-tooltip="Remove Custom Row"
                        class="custom-popconfirm"
            nz-popconfirm
            [nzPopconfirmOverlayClassName]="'custom-popconfirm-popover'"
            [nzPopconfirmTitle]="popconfirmTpl"
            nzPopconfirmPlacement="bottom">
                      <i nz-icon nzType="delete" nzTheme="fill"></i>
                    </button>
                  </td>
                </tr>
              </tbody>
            </nz-table>
          </div>
          <div class="text-right" style="margin-top: 10px;">
            <button nz-button nzType="dashed" (click)="addCustomRow(detailsFormArray, 'detail')" type="button">
              <i nz-icon nzType="plus"></i> Add Custom Field
            </button>
          </div>
          <nz-form-item nz-row class="register-area">
            <nz-form-control [nzSpan]="14">
              <div class="form-actions">
                <button nz-button type="button" (click)="goToPreviousStep()">Back</button>
                <button nz-button nzType="primary" type="submit">Next</button>
              </div>
            </nz-form-control>
          </nz-form-item>
        </form>
      </div>

      <div *ngIf="stepIndex === 2">
        <h2>Sourcing Needs</h2>
        <form nz-form [formGroup]="sourcingNeedsForm" (ngSubmit)="submitForm()">
          <nz-collapse [nzAccordion]="true" class="sourcing-needs-collapse-container" style="box-shadow: none;">
            <nz-collapse-panel *ngFor="let category of sourcingNeedsCategories; let i = index"
              [formGroupName]="category.key"
              [nzHeader]="getEmoji(category.requiredFlag) + '  ' + category.control.get('label')?.value"
              [nzActive]="i === 0" class="sourcing-needs-collapse-panel">

              <div class="answers-table-container" formArrayName="items">
                <nz-table [nzData]="getSourcingNeedsFormArray(category.key).controls" nzSize="middle"
                  [nzShowPagination]="false">
                  <thead>
                    <tr>
                      <th nzWidth="50px">Include</th>
                      <th>Need</th>
                      <th>Value</th>
                      <th nzWidth="50px">Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      *ngFor="let control of getSourcingNeedsFormArray(category.key).controls; let j = index; trackBy: trackByIndex"
                      [formGroup]="$any(control)">
                      <td><label nz-checkbox formControlName="selected"></label></td>
                      <td><textarea nz-input rows="2" formControlName="questionText"
                          [readOnly]="control.get('originalId')?.value !== null"></textarea></td>
                      <td><textarea nz-input rows="2" formControlName="answerText"></textarea></td>
                      <td>
                        <button nz-button nzDanger nzSize="small" nzShape="circle"
                          (click)="removeCustomRow(getSourcingNeedsFormArray(category.key), j)"
                          [disabled]="control.get('originalId')?.value !== null" type="button"
                          nz-tooltip="Remove Custom Need"
                            class="custom-popconfirm"
            nz-popconfirm
            [nzPopconfirmOverlayClassName]="'custom-popconfirm-popover'"
            [nzPopconfirmTitle]="popconfirmTpl"
            nzPopconfirmPlacement="bottom">
                          <i nz-icon nzType="delete" nzTheme="fill"></i>
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </nz-table>
              </div>
              <div class="text-right" style="margin-top: 10px;">
                <button nz-button nzType="dashed"
                  (click)="addCustomRow(getSourcingNeedsFormArray(category.key), 'detail')" type="button">
                  <i nz-icon nzType="plus"></i> Add Custom Need
                </button>
              </div>

            </nz-collapse-panel>
          </nz-collapse>
          <nz-form-item nz-row class="register-area">
            <nz-form-control [nzSpan]="14">
              <div class="form-actions">
                <button nz-button type="button" (click)="goToPreviousStep()">Back</button>
                <button nz-button nzType="primary" type="submit">Next</button>
              </div>
            </nz-form-control>
          </nz-form-item>
        </form>
      </div>

      <div *ngIf="showComplianceStep && stepIndex === 3">
        <h2>Compliance & Safety</h2>
        <form nz-form [formGroup]="complianceForm" (ngSubmit)="submitForm()">
          <nz-form-item>
            <nz-form-label [nzSm]="3" [nzXs]="24" style="display: flex;">Flexible Editing</nz-form-label>
            <nz-form-control [nzSm]="14" [nzXs]="24">
              <nz-switch formControlName="flexible"></nz-switch>
            </nz-form-control>
          </nz-form-item>

          <div class="answers-table-container" formArrayName="items">
            <nz-table #complianceTable [nzData]="complianceItemsArray.controls" nzSize="middle"
              [nzShowPagination]="false">
              <thead>
                <tr>
                  <th nzWidth="50px">Include</th>
                  <th [nzWidth]="complianceForm.get('flexible')?.value ? '30%' : null">Name <span
                      *ngIf="complianceForm.get('flexible')?.value" class="required-star">*</span></th>
                  <th *ngIf="complianceForm.get('flexible')?.value" nzWidth="120px">Currency <span
                      class="required-star">*</span></th>
                  <th *ngIf="complianceForm.get('flexible')?.value" nzWidth="120px">Amount</th>
                  <th *ngIf="complianceForm.get('flexible')?.value" nzWidth="120px">Exchange Rate</th>
                  <th *ngIf="complianceForm.get('flexible')?.value" nzWidth="120px">Amount (USD)</th>
                  <th *ngIf="!complianceForm.get('flexible')?.value">Yes / No</th>
                  <th nzWidth="50px">Actions</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let control of complianceItemsArray.controls; let j = index; trackBy: trackByIndex"
                  [formGroup]="$any(control)">
                  <td><label nz-checkbox formControlName="selected"></label></td>
                  <td><textarea nz-input rows="1" formControlName="name"></textarea></td>
                  <td *ngIf="complianceForm.get('flexible')?.value"><textarea nz-input rows="1"
                      formControlName="currency"></textarea></td>
                  <td *ngIf="complianceForm.get('flexible')?.value"><textarea nz-input rows="1"
                      formControlName="amount"></textarea></td>
                  <td *ngIf="complianceForm.get('flexible')?.value"><textarea nz-input rows="1"
                      formControlName="exchangeRate"></textarea></td>
                  <td *ngIf="complianceForm.get('flexible')?.value"><textarea nz-input rows="1"
                      formControlName="amountUsd"></textarea></td>
                  <td *ngIf="!complianceForm.get('flexible')?.value">
                    <nz-switch formControlName="simpleSelection"></nz-switch>
                  </td>
                  <td>
                    <button nz-button nzDanger nzSize="small" nzShape="circle"
                      (click)="removeCustomRow(complianceItemsArray, j)"
                      [disabled]="control.get('originalId')?.value !== null" type="button"
                      nz-tooltip="Remove Custom Item"
                        class="custom-popconfirm"
            nz-popconfirm
            [nzPopconfirmOverlayClassName]="'custom-popconfirm-popover'"
            [nzPopconfirmTitle]="popconfirmTpl"
            nzPopconfirmPlacement="bottom">
                      <i nz-icon nzType="delete" nzTheme="fill"></i>
                    </button>
                  </td>
                </tr>
              </tbody>
            </nz-table>
          </div>
          <div class="text-right" style="margin-top: 10px;">
            <button nz-button nzType="dashed" (click)="addCustomRow(complianceItemsArray, 'compliance')" type="button">
              <i nz-icon nzType="plus"></i> Add Custom Compliance Item
            </button>
          </div>
          <nz-form-item nz-row class="register-area">
            <nz-form-control [nzSpan]="14">
              <div class="form-actions">
                <button nz-button type="button" (click)="goToPreviousStep()">Back</button>
                <button nz-button nzType="primary" type="submit">Next</button>
              </div>
            </nz-form-control>
          </nz-form-item>
        </form>
      </div>

      <div *ngIf="stepIndex === (showComplianceStep ? 4 : 3)">
        <h2>Review & Generate</h2>
        <div id="pdf-content">

          <h3>Basic Details</h3>
          <nz-descriptions nzBordered nzSize="small" [nzColumn]="2">
            <nz-descriptions-item nzTitle="Event Name">{{ reviewData.eventDetails?.eventName }}</nz-descriptions-item>
            <nz-descriptions-item nzTitle="Event Start Date">{{ reviewData.eventDetails?.eventStartDate }}</nz-descriptions-item>
            <nz-descriptions-item nzTitle="Event End Date">{{ reviewData.eventDetails?.eventEndDate }}</nz-descriptions-item>
            <nz-descriptions-item nzTitle="Include Cover Page">{{ reviewData.eventDetails?.includeCoverPage ? '✅' : '❌' }}</nz-descriptions-item>
            <nz-descriptions-item nzTitle="Include Thank You Page">{{ reviewData.eventDetails?.includeThankYouPage ? '✅' : '❌' }}</nz-descriptions-item>
          </nz-descriptions>

          <h3 class="mt-4">Other Details</h3>
          <nz-table [nzData]="reviewData.otherDetails?.details" nzSize="small" [nzShowPagination]="false">
            <thead>
              <tr>
                <th nzWidth="80px">Included</th>
                <th>Detail</th>
                <th>Value</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let detail of reviewData.otherDetails?.details">
                <td>{{ detail.selected ? '✅' : '❌' }}</td>
                <td>{{ detail.questionText }}</td>
                <td>{{ detail.answerText }}</td>
              </tr>
            </tbody>
          </nz-table>

          <ng-container *ngFor="let category of sourcingNeedsCategories">
            <div *ngIf="reviewData.sourcingNeeds?.[category.key]?.items?.length > 0">
              <h3 class="mt-4">{{ reviewData.sourcingNeeds[category.key].label }}</h3>
              <nz-table [nzData]="reviewData.sourcingNeeds[category.key].items" nzSize="small" [nzShowPagination]="false">
                <thead>
                  <tr>
                    <th nzWidth="80px">Included</th>
                    <th>Need</th>
                    <th>Value</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let item of reviewData.sourcingNeeds[category.key].items">
                    <td>{{ item.selected ? '✅' : '❌' }}</td>
                    <td>{{ item.questionText }}</td>
                    <td>{{ item.answerText }}</td>
                  </tr>
                </tbody>
              </nz-table>
            </div>
          </ng-container>

          <ng-container *ngIf="showComplianceStep">
            <h3 class="mt-4">Compliance & Safety</h3>
            <nz-table [nzData]="reviewData.compliance?.items" nzSize="small" [nzShowPagination]="false">
              <thead>
                <tr>
                  <th nzWidth="80px">Included</th>
                  <th>Name</th>
                  <th *ngIf="reviewData.compliance?.flexible">Currency</th>
                  <th *ngIf="reviewData.compliance?.flexible">Amount</th>
                  <th *ngIf="reviewData.compliance?.flexible">Exchange Rate</th>
                  <th *ngIf="reviewData.compliance?.flexible">Amount (USD)</th>
                  <th *ngIf="!reviewData.compliance?.flexible">Yes / No</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let item of reviewData.compliance?.items">
                  <td>{{ item.selected ? '✅' : '❌' }}</td>
                  <td>{{ item.name }}</td>
                  <td *ngIf="reviewData.compliance?.flexible">{{ item.currency }}</td>
                  <td *ngIf="reviewData.compliance?.flexible">{{ item.amount }}</td>
                  <td *ngIf="reviewData.compliance?.flexible">{{ item.exchangeRate }}</td>
                  <td *ngIf="reviewData.compliance?.flexible">{{ item.amountUsd }}</td>
                  <td *ngIf="!reviewData.compliance?.flexible">{{ item.simpleSelection ? 'Yes' : 'No' }}</td>
                </tr>
              </tbody>
            </nz-table>
          </ng-container>

        </div>

        <div class="text-center mt-4">
          <div class="form-actions-review">
            <button nz-button type="button" (click)="goToPreviousStep()">Back</button>
            <button nz-button nzType="primary" (click)="onDownloadPdf()" [nzLoading]="isLoading">
              <i nz-icon nzType="file-pdf"></i> Download PDF
            </button>
          </div>
        </div>
      </div>

    </div>
  </div>
</div>

<ng-template #popconfirmTpl let-popconfirm="popconfirm">
    <div class="custom-popconfirm-header">
      <span class="custom-popconfirm-title">
          Confirm Deletion
      </span>
    </div>
    <div class="custom-popconfirm-icon-area">
        <span style="display: flex; justify-content: center; margin: 18px 0 8px 0;">
            <nz-icon nzType="warning-fill" nzTheme="fill" style="font-size: 32px; color: #ff6c6c;"></nz-icon>
        </span>
    </div>
    <div class="custom-popconfirm-message description">
        Are you sure you want to delete this item?<br />
        <span style="color:#888; font-size:14px;">This action cannot be undone.</span>
    </div>
</ng-template>
